import { z } from "zod";

//#region src/lib/exchange-rate/common.ts
let ExchangeRateSource = /* @__PURE__ */ function(ExchangeRateSource) {
	ExchangeRateSource["USD"] = "USD";
	ExchangeRateSource["EUR"] = "EUR";
	return ExchangeRateSource;
}({});
const ExchangeRatePairSchema = z.object({
	sourceCurrency: z.enum(ExchangeRateSource),
	destinationCurrency: z.string().length(3),
	rate: z.number().positive(),
	updatedAt: z.union([z.date(), z.string()])
});
const ExchangeRateResponseSchema = z.object({
	baseCode: z.enum(ExchangeRateSource),
	conversionRates: z.record(z.string().length(3), z.number()),
	timeLastUpdateUtc: z.string()
});
const ExchangeRateErrorSchema = z.object({
	result: z.literal("error"),
	"error-type": z.enum([
		"unsupported-code",
		"malformed-request",
		"invalid-key",
		"inactive-account",
		"quota-reached"
	])
});

//#endregion
export { ExchangeRateErrorSchema, ExchangeRatePairSchema, ExchangeRateResponseSchema, ExchangeRateSource };
//# sourceMappingURL=common.js.map